import SimpleBanner from "../components/landing/SimpleBanner";
import Terms from "../components/landing/Terms";

const TermsAndConditions = () => {
    return (
        <>
            <SimpleBanner title="Terms and Conditions of Service" />
            <Terms />
        </>
    );
};

export default TermsAndConditions;
